import React from 'react';
import LegalPage from './LegalPage';

const TermsPage: React.FC = () => {
  return (
    <LegalPage
      title="Terms and Conditions"
      subtitle="The terms that apply when you use GenLend's services."
      lastUpdated="To be finalised"
    >
      <h2>1. Introduction</h2>
      <p>
        These Terms and Conditions ("Terms") govern your use of the GenLend platform and any credit
        products offered by GenLend. By creating an account or applying for a loan, you confirm that
        you have read, understood, and agree to be bound by these Terms.
      </p>

      <h2>2. About GenLend</h2>
      <p>
        GenLend is a short-term credit provider focused on tertiary students in South Africa,
        particularly those awaiting NSFAS disbursements. GenLend operates in compliance with the
        National Credit Act, 2005 (NCA), and intends to be a registered credit provider with the
        National Credit Regulator (NCR). Our NCR registration number and full company details will
        be displayed here once finalised.
      </p>

      <h2>3. Eligibility</h2>
      <p>To apply for a loan with GenLend, you must:</p>
      <ul>
        <li>Be a South African citizen or permanent resident, aged 18 years or older.</li>
        <li>Be a registered tertiary student at a recognised South African institution.</li>
        <li>Hold a valid South African ID and an active South African bank account.</li>
        <li>Provide accurate, complete, and up-to-date information during the application.</li>
      </ul>

      <h2>4. Loan products</h2>
      <p>
        GenLend offers short-term loans in defined amounts and terms. The exact loan amount,
        interest, fees, repayment date, and total repayable will always be disclosed to you in
        writing before you sign your loan agreement. Approval is at GenLend's discretion and may
        depend on affordability and credit checks where required by law.
      </p>

      <h2>5. Fees, interest, and charges</h2>
      <p>
        Where applicable, GenLend's fees, interest, and other charges are within the maximums
        permitted by the National Credit Act and its regulations. A detailed breakdown is provided
        on each loan offer and again before disbursement. By accepting a loan offer, you agree to
        the fees disclosed in that offer.
      </p>

      <h2>6. Your obligations</h2>
      <ul>
        <li>You agree to repay all amounts due in accordance with the agreed repayment schedule.</li>
        <li>You agree to notify GenLend as soon as you are unable to make a payment.</li>
        <li>You agree to keep your contact details and banking information up to date.</li>
        <li>You will not use your loan for any unlawful purpose.</li>
      </ul>

      <h2>7. Missed payments and default</h2>
      <p>
        If you fail to make a payment when due, GenLend may, in line with the NCA, charge default
        administration fees and report the default to credit bureaux. Persistent default may lead
        to collection or legal action. We encourage you to contact us immediately if you are at risk
        of missing a payment so we can discuss options.
      </p>

      <h2>8. Privacy</h2>
      <p>
        We process your personal information in line with our <a href="/privacy">Privacy Policy</a> and
        the Protection of Personal Information Act, 2013 (POPIA).
      </p>

      <h2>9. Communications</h2>
      <p>
        By using GenLend, you agree to receive transactional communications via SMS, email, or
        in-app notifications. Marketing communications are optional and you may opt out at any time.
      </p>

      <h2>10. Account security</h2>
      <p>
        You are responsible for keeping your login credentials confidential. Notify us immediately
        if you suspect any unauthorised access to your account.
      </p>

      <h2>11. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, GenLend will not be liable for any indirect or
        consequential losses arising from your use of the platform. Nothing in these Terms limits
        any liability that cannot lawfully be excluded.
      </p>

      <h2>12. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. Material changes will be communicated to you
        via email, SMS, or in-app notice. Continued use of GenLend after changes take effect
        constitutes acceptance of the updated Terms.
      </p>

      <h2>13. Governing law and dispute resolution</h2>
      <p>
        These Terms are governed by the laws of the Republic of South Africa. Any dispute will, in
        the first instance, be attempted to be resolved directly with GenLend. Unresolved disputes
        may be referred to the National Credit Regulator or the Credit Ombud where applicable.
      </p>

      <div className="contact-card">
        <h2>Contact us</h2>
        <p>
          If you have any questions about these Terms, contact us on WhatsApp at{' '}
          <a href="https://wa.me/27722734008" target="_blank" rel="noopener noreferrer">072 273 4008</a>
          {' '}or email info@genlend.co.za.
        </p>
      </div>
    </LegalPage>
  );
};

export default TermsPage;
